module.exports = __webpack_public_path__ + "img/weather31.9afb459a.png";